import { useAtom } from 'jotai';
import { useEffect } from 'react';

import useAuth from './useAuth';

import {
  buildDataPopup,
  findDataPopup,
  insertPopupStore,
  popupsImageVideoAtom,
} from '@/store/popupImageVideo';
import { Maybe, UserInitialData } from '@/types';
import { PopupVideoImagenTO } from '@/types/popupImageVideo';

type PopupGetter = (
  userInitialData: Maybe<UserInitialData>
) => PopupVideoImagenTO | undefined;

export const usePopupImageVideo = (popupGetter: PopupGetter) => {
  const [popupsArray, setPopupsArray] = useAtom(popupsImageVideoAtom);
  const { userInitialData } = useAuth();
  const idUsuarioDT = userInitialData?.idUsuarioDT || -1;
  const fecha = userInitialData?.nombre_fecha || '-';
  // const popupSummary = userInitialData?.popups[0];
  const popupSummary = popupGetter(userInitialData);
  useEffect(() => {
    if (!popupSummary) {
      return;
    }
    const dataPP = buildDataPopup(idUsuarioDT, fecha, popupSummary);
    insertPopupStore(dataPP, popupsArray, setPopupsArray);
  }, [fecha, idUsuarioDT, popupSummary, popupsArray, setPopupsArray]);

  const dataPP2 = findDataPopup(
    popupsArray,
    idUsuarioDT,
    fecha,
    popupSummary?.id || -1
  );
  return dataPP2;
};
